import { MobileDateRangePickerWrapper } from "@components/Common/MobileDateRangePickerWrapper";
import DateRangePickerWrapper from "@components/Common/DateRangePickerWrapper";
import HeaderComponent from "@components/VerticalLayout/HeaderComponent";
import BreadcrumbOptions from "@pages/Reporting/BreadcrumbOptions";
import PageTitle from "@components/Common/PageTitle";

import { Box, Tooltip } from "@mui/material";

import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { getAdvancedPeriodStringParam } from "@helpers/general";
import React from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { CardBody, Container, Modal, Popover } from "reactstrap";
import { StyledPopoverBody } from "./StyledPopoverBody";
import uploadIcon from "../../assets/images/uploadIcon.svg";
import consult from "../../assets/images/consult.svg";
import { downloadCsv } from "./helpers";
import NoDataOverlay from "./NoDataOverlay";
import { TransactionsConnecsModal } from "./TransactionsConnecsModal";
import { CustomFooter } from "./CustomFooter";

function PaiementsConecsOverview() {
    const { t } = useTranslation();

    const { periodSlice, advancedDate } = useSelector((state: any) => state);

    const uuidEntity = localStorage.getItem("Uid_Entitie_User");
    const [currentPage, setCurrentPage] = React.useState(0);
    const [rows, setRows] = React.useState([]);
    const [isTransactionsModalOpened, setIsTransactionsModalOpened] =
        React.useState<boolean>(false);
    const [transactionsids, setTransactionsids] = React.useState<string>("");
    const pageSize = isMobile ? 5 : 10;

    const totalPages = Math.ceil(rows.length / pageSize);
    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
    const [isPopoverOpened, setIsPopoverOpened] = React.useState(false);

    const toggleOpenedPopover = React.useCallback(() => {
        setIsPopoverOpened((prevState) => !prevState);
    }, []);

    const toggleOpeningModal = React.useCallback(() => {
        setIsModalOpened((prevState) => !prevState);
    }, []);

    const columns: GridColDef[] = [
        {
            field: "date",
            headerName: "Date",

            width: 230,
            editable: false,
        },
        {
            field: "nbreCommandes",
            headerName: "Nombre des transactions",
            width: 230,
            editable: false,
        },
        {
            field: "total_amount",
            headerName: "Total transactions conecs",
            width: 230,
            editable: false,
        },
        // {
        //     field: "label",
        //     headerName: "Libellé",

        //     width: 230,
        //     editable: false,
        // },
        // {
        //     field: "base",
        //     headerName: "Base de calcul",

        //     width: 220,
        //     editable: false,
        // },
        {
            field: "commission",
            headerName: "Total des frais",

            width: 250,
            editable: false,
        },
        // {
        //     field: "idtransfer",
        //     headerName: "Id transfer",

        //     width: 250,
        //     editable: false,
        // },
        {
            field: "actions",
            flex: 1,
            headerName: "Actions",
            headerClassName: "custom-header",
            renderCell: (params: GridRenderCellParams) => (
                <div
                    style={{
                        display: "flex",
                        gap: "20px",
                        alignItems: "center",
                    }}
                >
                    <Tooltip title="Consulter transactions" arrow>
                        <button
                            type="button"
                            onClick={() => {
                                setIsTransactionsModalOpened(true);
                                setTransactionsids(params.row.transactionsids);
                            }}
                            id="ReportingIconButton"
                            aria-label="Open Transactions Modal"
                            data-bs-toggle="dropdown"
                            style={{
                                background: "none",
                                border: "none",
                                padding: 0,
                                cursor: "pointer",
                            }}
                        >
                            <img
                                src={consult}
                                height={30}
                                width={30}
                                alt="Open Transactions Modal"
                                style={{
                                    backgroundColor: "transparent",
                                    mixBlendMode: "multiply",
                                }}
                            />
                        </button>
                    </Tooltip>
                    <Tooltip title="Télécharger transactions" arrow>
                        <button
                            type="button"
                            onClick={async () => {
                                const dateTransactions = params.row.date
                                    .split(",")[0]
                                    .trim()
                                    .replace(/ /g, "_");
                                await downloadCsv(
                                    params.row.transactionsids,
                                    dateTransactions
                                );
                            }}
                            aria-label="Download CSV"
                            style={{
                                background: "none",
                                border: "none",
                                padding: 0,
                                cursor: "pointer",
                            }}
                        >
                            <img
                                src={uploadIcon}
                                height={30}
                                width={30}
                                alt="Download CSV"
                                style={{
                                    backgroundColor: "transparent",
                                    mixBlendMode: "multiply",
                                }}
                            />
                        </button>
                    </Tooltip>
                </div>
            ),
            minWidth: 100,
            sortable: false,
        },
    ];

    const handlePageChange = (newPage: number) => {
        if (newPage >= 0 && newPage < totalPages) {
            setCurrentPage(newPage);
        }
    };

    const handleToggleOpenedPopover = React.useCallback(() => {
        toggleOpenedPopover();
    }, [toggleOpenedPopover]);

    const handleToggleOpeningModal = React.useCallback(() => {
        toggleOpeningModal();
    }, [toggleOpeningModal]);

    const getConecsTransfers = async () => {
        const filterPeriod = getAdvancedPeriodStringParam(
            periodSlice,
            advancedDate
        );
        const encodedFilterPeriod = encodeURIComponent(filterPeriod);

        const response = await fetch(
            `${process.env.REACT_APP_ADMIN_ACCESS}/getConecsTransfers?uuidEntity=${uuidEntity}&filterPeriod=${encodedFilterPeriod}`
        );
        const data = await response.json();
        return data.map((item: any, index: number) => {
            return {
                id: index,
                date: item.date,
                commission: item.commission,
                nbreCommandes: item.nbreCommandes,
                total_amount: item.total_amount,
                transactionsids: item.transactionsids,
            };
        });
    };

    React.useEffect(() => {
        const loadRows = async () => {
            const fetchedRows = await getConecsTransfers();
            setRows(fetchedRows);
        };

        loadRows();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uuidEntity, periodSlice, advancedDate]);

    return (
        <React.Fragment>
            <div>
                <PageTitle title="Paiements conecs SoftaveraPay" />
                <div className="">
                    <BreadcrumbOptions
                        currentLink={[
                            {
                                item: t("SOFTAVERAPAY"),
                                link: `${process.env.REACT_APP_PORTAIL_API}`,
                            },
                            {
                                item: t(`${"Reporting Conecs"}`),
                                link: `${"Paiements"}`,
                            },
                            {
                                item: t(`${"Transactions conecs"}`),
                                link: `${"Paiements"}`,
                            },
                        ]}
                    />
                    <Container fluid>
                        <HeaderComponent
                            title={t(
                                `The 'Transactions' report displays the automatic payments from a balance account over a given period, including the date, captured funds, adjustments, and the net payment. After adjustments (fees, commissions, etc.), the final amount is credited to the user's bank account.`
                            )}
                        />
                        <CardBody
                            style={{
                                padding: "1px",
                                backgroundColor: "white",
                                marginTop: "10px",
                            }}
                        >
                            <div>
                                <div className="transaction-overview">
                                    <h2>Transfers conecs overview</h2>
                                    <div className="filter-buttons">
                                        <button
                                            id="date-range-picker-popover"
                                            type="button"
                                            className="filter-button active"
                                            onClick={handleToggleOpenedPopover}
                                        >
                                            {t(`${periodSlice.date}`)}
                                        </button>
                                        {isPopoverOpened &&
                                            (isMobile === false ? (
                                                <Popover
                                                    placement="top"
                                                    isOpen={isPopoverOpened}
                                                    target="date-range-picker-popover"
                                                    toggle={toggleOpenedPopover}
                                                    trigger="legacy"
                                                >
                                                    <StyledPopoverBody>
                                                        <DateRangePickerWrapper
                                                            toggleOpenedPopover={
                                                                toggleOpenedPopover
                                                            }
                                                            isAdvancedReporting={
                                                                false
                                                            }
                                                        />
                                                    </StyledPopoverBody>
                                                </Popover>
                                            ) : (
                                                <Modal
                                                    isOpen={isModalOpened}
                                                    toggle={
                                                        handleToggleOpeningModal
                                                    }
                                                    className="defined-range-modal__clz"
                                                    centered
                                                    fade={false}
                                                >
                                                    <MobileDateRangePickerWrapper
                                                        toggleOpeningModal={
                                                            handleToggleOpeningModal
                                                        }
                                                    />
                                                </Modal>
                                            ))}

                                        <button
                                            className="filter-button d-none"
                                            type="button"
                                        >
                                            Libellé
                                        </button>
                                    </div>
                                </div>
                                <Box sx={{ height: 500, width: "100%" }}>
                                    <DataGrid
                                        rows={rows.slice(
                                            currentPage * pageSize,
                                            (currentPage + 1) * pageSize
                                        )}
                                        columns={columns.map((column) => ({
                                            ...column,
                                        }))}
                                        pageSize={pageSize}
                                        disableSelectionOnClick
                                        components={{
                                            NoRowsOverlay: NoDataOverlay,
                                            Footer: CustomFooter,
                                        }}
                                        componentsProps={{
                                            footer: {
                                                currentPage,
                                                onPageChange: handlePageChange,
                                                totalPages,
                                            },
                                        }}
                                    />
                                </Box>
                            </div>
                        </CardBody>
                    </Container>
                </div>
            </div>
            <TransactionsConnecsModal
                isModalOpened={isTransactionsModalOpened}
                setIsModalOpened={setIsTransactionsModalOpened}
                transactionsids={transactionsids}
            />
        </React.Fragment>
    );
}

export default PaiementsConecsOverview;
